import { isEqual, pick } from 'lodash'
import {
  GetProvidersFilter,
  GetProvidersSearch,
  SearchParams,
} from 'src/api/types'
import { CATEGORY } from 'src/refactor/helpers/constants'
import { TGenderOptions } from 'src/shared/types'
import { getSearchType } from './helpers'
import { State } from './types'

export const defaultState: Omit<State, 'search' | 'itemType'> = {
  category: CATEGORY.DOCTOR,
  isLoading: true,
  listView: 'list',
  filter: {
    distance: 20,
    withVirtualCare: false,
    newPatients: false,
    gender: 'unknown',
    specialtyFilters: [],
    providerType: 'all',
  },
  hasFilterChanged: false,
  isFirstSearch: true,
  viewPractitionerList: [],
  specialtyFilters: [],
  previousDistance: 20,
  isRequestCanceled: false,
  expandedPractice: null,
}

const formatUrlParams = (
  params: Record<keyof SearchParams, string | string[]>
): {
  category: CATEGORY
  search: GetProvidersSearch
  filter: GetProvidersFilter
} => {
  const {
    serviceLines,
    name,
    placeId,
    addressLabel = '',
  } = pick(params, ['serviceLines', 'name', 'placeId', 'addressLabel'])
  const {
    distance = '20',
    gender = 'unknown',
    newPatients = 'false',
    withVirtualCare = 'false',
    specialtyFilters = [],
  } = pick(params, [
    'distance',
    'gender',
    'newPatients',
    'withVirtualCare',
    'specialtyFilters',
  ])

  const search: GetProvidersSearch = {
    name: name as string,
    serviceLines: serviceLines as string,
    placeId: placeId as string,
    addressLabel: addressLabel as string,
  }
  const filter: GetProvidersFilter = {
    distance: parseInt(distance as string, 10),
    gender: gender as TGenderOptions,
    newPatients: newPatients === 'true',
    withVirtualCare: withVirtualCare === 'true',
    specialtyFilters: Array.isArray(specialtyFilters)
      ? specialtyFilters
      : specialtyFilters.split(','),
    providerType: 'all',
  }

  return { search, filter, category: params.category as CATEGORY }
}

export const getInitialState = (
  params: Record<keyof SearchParams, string | string[]>
): State => {
  const { category, search, filter } = formatUrlParams(params)
  const itemType = getSearchType(search, category)

  return {
    ...defaultState,
    category,
    search,
    filter: {
      ...defaultState.filter,
      ...filter,
    },
    itemType,
    hasFilterChanged: !isEqual(defaultState.filter, filter),
  }
}
